const getComparatorType = (comparator?: string | null) => {
  if (comparator === 'et_contain' || comparator === 'EtContain') {
    return 'EtContain';
  } else if (comparator === 'et_equal' || comparator === 'EtEqual') {
    return 'EtEqual';
  } else return '';
};

export default getComparatorType;
